import React from "react";

const BarLoading = () => {
  return (
    <div role="status" className="bc-animate-bcpulse bc-w-full">
      <div className="bc-flex bc-flex-row bc-w-full bc-justify-between bc-items-center bc-gap-[10px] bc-px-[11px] desktop:bc-px-[24px] bc-py-[5px] bc-min-h-[74px] desktop:bc-h-[86px]">
        <div className="bc-flex bc-flex-row bc-gap-[10px]">
          <div className="!bc-flex desktop:!bc-hidden bc-w-[40px] bc-h-[40px] bc-bg-[#dcdddc] bc-rounded-[6px]"></div>
          <div className="bc-hidden desktop:!bc-flex bc-w-[60px] bc-h-[40px] bc-bg-[#dcdddc] bc-rounded-[6px]"></div>
          <div className="bc-hidden desktop:!bc-flex bc-w-[68px] bc-h-[40px] bc-bg-[#dcdddc] bc-rounded-[6px]"></div>
        </div>
        <div className="bc-flex bc-flex-row bc-gap-[10px]">
          <div className="!bc-flex bc-w-[40px] bc-h-[40px] bc-bg-[#dcdddc] bc-rounded-[6px]"></div>
        </div>
      </div>
    </div>
  );
};

export default BarLoading;
